module.exports = __webpack_public_path__ + "static/media/nic.d5e895d9.png";